module.exports = __webpack_public_path__ + "img/naked-insurance-banner-square-3.8967d8b6.jpg";